@use "sass:color";
@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.overview {
  display: flex;
  flex-direction: row;
  gap: 5%;

  .module {
    display: flex;
    flex-direction: column;
    min-width: 419px;
    flex: 2 0 50%;
    align-self: stretch;
  }

  .services-chart {
    display: flex;
    flex-direction: column;
    flex: 1 0 33%;
    position: relative;
    top: -40px;

    :global .donut-chart {
      width: 358px;
    }

    .top-services {
      display: flex;
      flex-direction: column;
      position: relative;
      margin: 0 0 0 1em;
      bottom: 16px;

      @include responsive.large-desktop-and-up {
        bottom: -34px;
      }

      h3 {
        margin: 0;
        color: colors.$neutrals-dark-grey;
      }

      li {
        display: flex;
        flex-direction: row;
        overflow: hidden;
        align-items: center;
        gap: 10px;

        img {
          width: 24px;
          height: 24px;
          filter: drop-shadow(0px 100px 0 #000);
          transform: translateY(-100px);
        }

        p {
          font-weight: 700;
          line-height: 28px;
          margin: 8px 0;
        }
      }
    }
  }
}

.stat-box {
  padding: 1.5em;
  margin-bottom: 0.2em;
  background-color: colors.$neutrals-light-grey;

  &.rounded {
    border-radius: 8px;
  }

  &.negative-text {
    h3 {
      color: colors.$primary-white
    }

    p {
      color: color.adjust(colors.$primary-white, $alpha: -0.18);
    }
  }
}

.step-module {
  display: flex;
  flex-direction: row;
  gap: 1.5em;
}


.step-header {
  display: block;
}

div.steps {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
  align-items: center;

  ul {
    gap: 1em;
    max-width: 56em;

    li.step {
      padding: 0;
      width: 14em;

      & > div {
        cursor: default;
        padding: 0;

        & > div {
          padding: 1.2em;
        }
      }
    }
  }

  p {
    margin-top: 0;
    font-size: 14px;
  }

  span.step-name {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
  }
}
